import { MoreHorizontal } from '@griply/assets';
import React, { useRef, useState } from 'react';
import { Colors, Sizes } from 'shared/components/ui/icon-button';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';

import * as Styled from './setup-checklist-menu.style';

export type SetupChecklistMenuProps = {
  onHide: () => void;
  hideLabel: string;
};

export const SetupChecklistMenu: React.FC<SetupChecklistMenuProps> = ({
  onHide,
  hideLabel,
}) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((previous) => !previous);
  const close = () => setOpen(false);
  const handleHide = () => {
    close();
    onHide();
  };

  return (
    <>
      <Styled.Trigger
        ref={triggerRef}
        icon={MoreHorizontal}
        onClick={toggle}
        color={Colors.Inherit}
        size={Sizes.Small}
        noHover
        aria-label={hideLabel}
      />

      {open && (
        <PopupMenu
          referenceElement={triggerRef}
          position="bottom-end"
          onOutside={close}
        >
          <PopupMenuList>
            <PopupMenuListItem>
              <PopupMenuButton onClick={handleHide} tabIndex={0}>
                {hideLabel}
              </PopupMenuButton>
            </PopupMenuListItem>
          </PopupMenuList>
        </PopupMenu>
      )}
    </>
  );
};
